// @ts-nocheck

import * as React from "react"
import Svg, { SvgProps, Defs, Path, Use, G } from "react-native-svg"

// Note: this doesn't have native support: need to
// use react-native-svg-transformer
const LoginTypingPrivate = (props: SvgProps) => {
  return (
    <Svg viewBox="0 0 355 365" {...props}>
      <Defs>
        <G id="LoginTypingPrivate-puzmoKeyboard-NO-BGt145" overflow="visible">
          <Use xlinkHref="#LoginTypingPrivate-puzmoBody" transform="matrix(.998 -.061 .061 .998 -258.85 -72.5)">
            <animateTransform
              attributeName="transform"
              additive="replace"
              type="translate"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.22899;.229;.55899;.559;1"
              values="-168.197,-2.215;-168.197,-2.215;-168.15,-2.25;-168.15,-2.25;-168.197,-2.215;-168.197,-2.215"
              calcMode="discrete"
            />
            <animateTransform
              attributeName="transform"
              additive="sum"
              type="rotate"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.22899;.229;.55899;.559;1"
              values="-3.481,0,0;-3.481,0,0;0,0,0;0,0,0;-3.481,0,0;-3.481,0,0"
              calcMode="discrete"
            />
            <animateTransform
              attributeName="transform"
              additive="sum"
              type="translate"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.22899;.229;.55899;.559;1"
              values="-86.2,-75.65;-86.2,-75.65;-86.25,-75.65;-86.25,-75.65;-86.2,-75.65;-86.2,-75.65"
              calcMode="discrete"
            />
          </Use>
          <Use xlinkHref="#LoginTypingPrivate-PuzmoHandsType-Firstd118" transform="translate(-248.75 48.8)" />
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-puzmoeyef4" transform="matrix(-.814 .58 .58 .814 -148.3 -39.45)" />
            <Use xlinkHref="#LoginTypingPrivate-puzmoeyef4" transform="matrix(-.705 .709 .709 .705 -116.5 -47.15)" />
            <Use xlinkHref="#LoginTypingPrivate-puzmoMouthf4" transform="matrix(-.801 .598 .598 .801 -101 -38.45)" />
            <animate attributeName="display" repeatCount="indefinite" dur="3.933s" keyTimes="0;.559;1" values="none;inline;inline" />
          </G>
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-puzmoeyef0o27" transform="matrix(.908 .419 -.419 .908 -145.75 -15.3)" />
            <Use xlinkHref="#LoginTypingPrivate-puzmoeyef4" transform="matrix(.908 .419 -.419 .908 -188.8 -15.2)" />
            <Use xlinkHref="#LoginTypingPrivate-puzmoMouthf4" transform="matrix(.996 .092 -.092 .996 -196.65 4.7)" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.229;.559;1"
              values="none;inline;none;none"
            />
          </G>
          <G>
            <Use xlinkHref="#LoginTypingPrivate-puzmoeyef4" transform="matrix(-.814 .58 .58 .814 -148.3 -39.45)" />
            <Use xlinkHref="#LoginTypingPrivate-puzmoeyef4" transform="matrix(-.705 .709 .709 .705 -116.5 -47.15)" />
            <Use xlinkHref="#LoginTypingPrivate-puzmoMouthf4" transform="matrix(-.801 .598 .598 .801 -101 -38.45)" />
            <animate attributeName="display" repeatCount="indefinite" dur="3.933s" keyTimes="0;.229;1" values="inline;none;none" />
          </G>
        </G>
        <G id="LoginTypingPrivate-puzmoeye_0.4" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer1_0_1_STROKES" />
          </G>
        </G>
        <G id="LoginTypingPrivate-puzmoeyef4" overflow="visible">
          <Use xlinkHref="#LoginTypingPrivate-puzmoeye_0.4" />
        </G>
        <G id="LoginTypingPrivate-puzmoMouth_0.4" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer2_0_1_STROKES" />
          </G>
        </G>
        <G id="LoginTypingPrivate-puzmoMouthf4" overflow="visible">
          <Use xlinkHref="#LoginTypingPrivate-puzmoMouth_0.4" />
        </G>
        <G id="LoginTypingPrivate-puzmoeye_0.0" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer3_0_FILL" />
          </G>
        </G>
        <G id="LoginTypingPrivate-puzmoeyef0o27" overflow="visible">
          <Use xlinkHref="#LoginTypingPrivate-puzmoeye_0.0" />
        </G>
        <G id="PuzmoHandsType First_1" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer4_0_1_STROKES" />
          </G>
        </G>
        <G id="PuzmoHandsType First_1.3" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer5_0_1_STROKES" />
          </G>
        </G>
        <G id="PuzmoHandsType First_1.9" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer6_0_1_STROKES" />
          </G>
        </G>
        <G id="PuzmoHandsType First_1.12" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer7_0_1_STROKES" />
          </G>
        </G>
        <G id="PuzmoHandsType First_1.15" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer8_0_1_STROKES" />
          </G>
        </G>
        <G id="PuzmoHandsType First_1.18" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer9_0_1_STROKES" />
          </G>
        </G>
        <G id="LoginTypingPrivate-PuzmoHandsType-Firstd118" overflow="visible">
          <G display="none">
            <Use xlinkHref="#PuzmoHandsType First_1.18" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.153;.203;.356;.407;.559;.61;.763;.814;.966;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;inline"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#PuzmoHandsType First_1.15" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.127;.153;.331;.356;.534;.559;.737;.763;.941;.966;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#PuzmoHandsType First_1.12" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.102;.127;.305;.331;.508;.534;.712;.737;.915;.941;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#PuzmoHandsType First_1.9" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.076;.102;.28;.305;.483;.508;.686;.712;.89;.915;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#PuzmoHandsType First_1.3" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.025;.076;.229;.28;.432;.483;.636;.686;.839;.89;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
          <G>
            <Use xlinkHref="#PuzmoHandsType First_1" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.025;.203;.229;.407;.432;.61;.636;.814;.839;1"
              values="inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="translate(-.4 -5.2)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="matrix(-1 0 0 1 156.4 -5.2)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="matrix(.818 .576 -.576 .818 19.2 -9.1)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="matrix(-1 0 0 1 160.4 -14.4)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypet3o18d118" transform="matrix(.844 -.537 .537 .844 -23.1 5.1)" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.153;.203;.356;.407;.559;.61;.763;.814;.966;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;inline"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="translate(-.4 -5.2)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="matrix(-1 0 0 1 156.4 -5.2)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="matrix(.818 .576 -.576 .818 19.2 -9.1)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypet3o15d118" transform="matrix(-1 0 0 1 160.4 -14.4)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypeo15d118" transform="matrix(.844 -.537 .537 .844 -23.1 5.1)" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.127;.153;.331;.356;.534;.559;.737;.763;.941;.966;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="translate(-.4 -5.2)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="matrix(-1 0 0 1 156.4 -5.2)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypet3o12d118" transform="matrix(.818 .576 -.576 .818 19.2 -9.1)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypeo12d118" transform="matrix(-1 0 0 1 160.4 -14.4)" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.102;.127;.305;.331;.508;.534;.712;.737;.915;.941;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="translate(-.4 -5.2)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypet9o9d118" transform="matrix(-1 0 0 1 156.4 -5.2)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypeo9d118" transform="matrix(.818 .576 -.576 .818 19.2 -9.1)" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.076;.102;.28;.305;.483;.508;.686;.712;.89;.915;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxTypet3o3d118" transform="translate(-.4 -5.2)" />
            <Use xlinkHref="#LoginTypingPrivate-fxTypeo3d118" transform="matrix(-.885 -.465 -.465 .885 176.7 -5.05)" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.025;.076;.229;.28;.432;.483;.636;.686;.839;.89;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
          <G>
            <Use xlinkHref="#LoginTypingPrivate-fxTyped118" transform="translate(-.4 -5.2)" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.025;.203;.229;.407;.432;.61;.636;.814;.839;1"
              values="inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
        </G>
        <G id="LoginTypingPrivate-puzmoBody_0.0" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer10_0_FILL" />
          </G>
        </G>
        <G id="LoginTypingPrivate-puzmoBody" overflow="visible">
          <Use xlinkHref="#LoginTypingPrivate-puzmoBody_0.0" />
        </G>
        <G id="LoginTypingPrivate-fxType_0.0" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer11_0_1_STROKES" />
          </G>
        </G>
        <G id="LoginTypingPrivate-fxTyped118" overflow="visible">
          <Use xlinkHref="#LoginTypingPrivate-fxType_0.0" />
        </G>
        <G id="LoginTypingPrivate-fxType_0.3" overflow="visible">
          <G>
            <Use xlinkHref="#LoginTypingPrivate-Layer12_0_1_STROKES" />
          </G>
        </G>
        <G id="LoginTypingPrivate-fxTypet3o3d118" overflow="visible">
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxType_0.3" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.025;.051;.076;.102;.127;.153;.178;.203;.229;.254;.28;.305;.331;.356;.381;.407;.432;.458;.483;.508;.534;.559;.585;.61;.636;.661;.686;.712;.737;.763;.788;.814;.839;.864;.89;.915;.941;.966;.992;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;inline"
            />
          </G>
        </G>
        <G id="LoginTypingPrivate-fxTypeo3d118" overflow="visible">
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxType_0.3" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.051;.076;.102;.127;.153;.178;.203;.229;.254;.28;.305;.331;.356;.381;.407;.432;.458;.483;.508;.534;.559;.585;.61;.636;.661;.686;.712;.737;.763;.788;.814;.839;.864;.89;.915;.941;.966;.992;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxType_0.0" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.025;.051;.076;.102;.127;.153;.178;.203;.229;.254;.28;.305;.331;.356;.381;.407;.432;.458;.483;.508;.534;.559;.585;.61;.636;.661;.686;.712;.737;.763;.788;.814;.839;.864;.89;.915;.941;.966;.992;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;inline"
            />
          </G>
        </G>
        <G id="LoginTypingPrivate-fxTypet9o9d118" overflow="visible" />
        <G id="LoginTypingPrivate-fxTypeo9d118" overflow="visible">
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxType_0.0" />
            <animate attributeName="display" repeatCount="indefinite" dur="3.933s" keyTimes="0;.076;1" values="none;inline;inline" />
          </G>
        </G>
        <G id="LoginTypingPrivate-fxTypet3o12d118" overflow="visible">
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxType_0.3" />
            <animate attributeName="display" repeatCount="indefinite" dur="3.933s" keyTimes="0;.102;1" values="none;inline;inline" />
          </G>
        </G>
        <G id="LoginTypingPrivate-fxTypeo12d118" overflow="visible">
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxType_0.0" />
            <animate attributeName="display" repeatCount="indefinite" dur="3.933s" keyTimes="0;.102;1" values="none;inline;inline" />
          </G>
        </G>
        <G id="LoginTypingPrivate-fxTypet3o15d118" overflow="visible">
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxType_0.3" />
            <animate attributeName="display" repeatCount="indefinite" dur="3.933s" keyTimes="0;.127;1" values="none;inline;inline" />
          </G>
        </G>
        <G id="LoginTypingPrivate-fxTypeo15d118" overflow="visible">
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxType_0.0" />
            <animate attributeName="display" repeatCount="indefinite" dur="3.933s" keyTimes="0;.127;1" values="none;inline;inline" />
          </G>
        </G>
        <G id="LoginTypingPrivate-fxTypet3o18d118" overflow="visible">
          <G display="none">
            <Use xlinkHref="#LoginTypingPrivate-fxType_0.3" />
            <animate
              attributeName="display"
              repeatCount="indefinite"
              dur="3.933s"
              keyTimes="0;.153;.178;.203;.229;.254;.28;.305;.331;.356;.381;.407;.432;.458;.483;.508;.534;.559;.585;.61;.636;.661;.686;.712;.737;.763;.788;.814;.839;.864;.89;.915;.941;.966;.992;1"
              values="none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
            />
          </G>
        </G>
        <G id="LoginTypingPrivate-Layer10_0_FILL">
          <Path
            fill="#FFBB03"
            stroke="none"
            d="M148.1 20.75Q122.4 -.9 86.05 .05 49.2 -.75 23.3 20.85 11.3 31.9 5.65 45.15 .2 57.9 -.3 74.95 -1.15 107.75 22.65 129.7 49.15 151.35 87.4 151.35 122.35 151.45 146.85 129.55 171.9 106.45 172.5 74.7 172.8 42.35 148.1 20.75Z"
          />
        </G>
        <G id="LoginTypingPrivate-Layer3_0_FILL">
          <Path
            fill="#191F2A"
            stroke="none"
            d="M5.75 16.75Q9 18.15 11.9 16.7 14.9 15.3 15.8 11.9 16.75 8.6 15.15 5.25 13.55 1.9 10.35 .6 7.15 -.7 4.2 .7 1.25 2.1 .3 5.45 -.65 8.8 .95 12.1 2.6 15.45 5.75 16.75Z"
          />
        </G>
        <Path
          id="LoginTypingPrivate-Layer12_0_1_STROKES"
          stroke="#FFBB03"
          strokeWidth="4"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M-20.4 48.8L-20 48.8M-17.6 29.2L-17.2 29.2"
        />
        <Path
          id="LoginTypingPrivate-Layer11_0_1_STROKES"
          stroke="#FFBB03"
          strokeWidth="4"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M-16 30.8L-11.2 35.2M-18.4 46.8L-12.4 44.8"
        />
        <Path
          id="LoginTypingPrivate-Layer9_0_1_STROKES"
          stroke="#FFBB03"
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M137.55 .8Q145.35 7 149.1 13.5 152.85 20 152 26 151.2 31.95 144.05 34.8 136.95 37.65 121.95 40.7M21.65 4Q16.25 11.2 14.15 14.2 12.05 17.15 9.1 23.4 6.15 29.55 13.45 31.75 20.8 33.85 36.45 27.2"
        />
        <Path
          id="LoginTypingPrivate-Layer8_0_1_STROKES"
          stroke="#FFBB03"
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M138.75 4Q144.15 11.2 146.25 14.2 148.35 17.15 151.3 23.4 154.25 29.55 146.95 31.75 139.6 33.85 123.95 27.2M22.85 .8Q15.05 7 11.3 13.5 7.55 20 8.4 26 9.2 31.95 16.35 34.8 23.45 37.65 38.45 40.7"
        />
        <Path
          id="LoginTypingPrivate-Layer7_0_1_STROKES"
          stroke="#FFBB03"
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M137.55 .8Q145.35 7 149.1 13.5 152.85 20 152 26 151.2 31.95 144.05 34.8 136.95 37.65 121.95 40.7M21.65 4Q16.25 11.2 14.15 14.2 12.05 17.15 9.1 23.4 6.15 29.55 13.45 31.75 20.8 33.85 36.45 27.2"
        />
        <Path
          id="LoginTypingPrivate-Layer6_0_1_STROKES"
          stroke="#FFBB03"
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M138.75 4Q144.15 11.2 146.25 14.2 148.35 17.15 151.3 23.4 154.25 29.55 146.95 31.75 139.6 33.85 123.95 27.2M22.85 .8Q15.05 7 11.3 13.5 7.55 20 8.4 26 9.2 31.95 16.35 34.8 23.45 37.65 38.45 40.7"
        />
        <Path
          id="LoginTypingPrivate-Layer5_0_1_STROKES"
          stroke="#FFBB03"
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M137.55 .8Q145.35 7 149.1 13.5 152.85 20 152 26 151.2 31.95 144.05 34.8 136.95 37.65 121.95 40.7M21.65 4Q16.25 11.2 14.15 14.2 12.05 17.15 9.1 23.4 6.15 29.55 13.45 31.75 20.8 33.85 36.45 27.2"
        />
        <Path
          id="LoginTypingPrivate-Layer4_0_1_STROKES"
          stroke="#FFBB03"
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M138.75 4Q144.15 11.2 146.25 14.2 148.35 17.15 151.3 23.4 154.25 29.55 146.95 31.75 139.6 33.85 123.95 27.2M22.85 .8Q15.05 7 11.3 13.5 7.55 20 8.4 26 9.2 31.95 16.35 34.8 23.45 37.65 38.45 40.7"
        />
        <Path
          id="LoginTypingPrivate-Layer2_0_1_STROKES"
          stroke="#191F2A"
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M31.1 20.05Q36.1 20.7 41.15 18.15 45.65 15.85 47.7 12.45"
        />
        <Path
          id="LoginTypingPrivate-Layer1_0_1_STROKES"
          stroke="#191F2A"
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M2.4 12.4L14.4 6.4"
        />
      </Defs>
      <G id="LoginTypingPrivate-Scene-1t145" overflow="visible">
        <Use xlinkHref="#LoginTypingPrivate-puzmoKeyboard-NO-BGt145" transform="translate(346 178)" />
      </G>
    </Svg>
  )
}

export { LoginTypingPrivate }
